// this style is in right a panel, out of the feature scope, so use as the global pattern
import { convertToLocalStyle } from './utils/convert-style';
import { scrollbarStyle } from './shared-styles-from-theme-fluent';

export const audienceCombinedListStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.combined-list-detail-panel': {
    width: 800,

    '& > div:first-child > div:first-child': {

      '& .dropdown.btn-group': {
        marginLeft: '-8px',
      },

      '& #audience-set-relationship-selection': {
        border: `1px solid ${palette.neutralSecondary}`,
        padding: '0px 10px 0px 10px',
        fontWeight: 400,
        color: palette.neutralPrimary,
      },

      '& .dropdown-menu': {
        width: '230px',
      },
    },
    '& .campaign-level-conversion-goal .double-list-box': {
      padding: 0,
      width: 778,
      margin: '0px 0px',
      ...convertToLocalStyle(scrollbarStyle({ palette })),

      '& .category-action': {
        marginTop: '0px !important',
      },

      '& .row': {
        margin: 0,
      },

      '& .col-sm-12': {
        padding: 0,
      },

      '& .col-sm-5 > .row:first-child': {
        backgroundColor: 'transparent',
      },
      '& .source .btn-default': {
        border: 'none',
        textAlign: 'left',
      },
      '& .btn-default': {
        border: 'none',
      },
      '& label.control-label': {
        height: '30px',
        display: 'inline',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '38px',
        paddingTop: '5px',
        paddingLeft: '3px',
      },

      '& .c113,.c118,.c1112': {
        backgroundColor: 'transparent',
      },

      '& .button-add-remove': {
        // padding: '0px 0px 0px 12px',
        backgroundColor: 'transparent',
      },
      '& .button-add-remove:hover': {
        // padding: '0px 0px 0px 12px',
        backgroundColor: 'transparent',
      },

      '& .button-back': {
        minWidth: '30px',
        backgroundColor: 'transparent',
      },
      '& .button-back:hover': {
        backgroundColor: 'transparent',
      },

      '& .glyphicon': {
        fontFamily: iconFontFamily,
      },
      '& .glyphicon-chevron-left:before': {
        content: '"\\E76B"',
      },
      '& .glyphicon-chevron-right:before': {
        content: '"\\E76C"',
      },
      '& .glyphicon-chevron-up:before': {
        content: '"\\E70E"',
      },
      '& .glyphicon-chevron-down:before': {
        content: '"\\E70D"',
      },

      '& .source': {
        border: `1px solid ${palette.neutralSecondary}`,
        padding: 0,
        width: 384,

        '& .search-box': {
          height: 30,
          width: 375,
          margin: 0,

          '& .inputGroup': {
            height: 30,
            width: 375,
            margin: 0,
            display: 'flex',

            '& .iconba': {
              fontFamily: iconFontFamily,
            },

            '& .iconba-Search': {
              display: 'none',
            },

            '& input.input': {
              margin: '0px 10px',
              height: 30,
              width: 355,
              marginRight: -30,
              paddingRight: 30,
            },

            '& .iconba-Forward': {
              cursor: 'pointer',
              visibility: 'visible !important',
              marginTop: 2,
              color: palette.themePrimary,
              '&:before': {
                content: '"\\E721"',
              },
              '&:hover': {
                color: '#004578',
              },
            },
          },
        },

        '& .source-categories': {
          margin: 0,
          padding: 0,
          width: 382,

          '& .btn-group-vertical': {
            marginTop: '5px',
            width: 375,

            '& button.source-category': {
              margin: 0,
              padding: 0,
              height: 'auto',

              '& .container-fluid': {
                padding: 0,

                '& .row': {
                  margin: 0,

                  '& .col-sm-11': {
                    width: 316,
                    padding: '0px 0px 0px 13px',

                    '& .category-title': {
                      fontSize: '14px',
                      float: 'none',
                      padding: 0,
                    },

                    '& .category-description': {
                      fontSize: '0px',
                      margin: 0,
                    },
                  },

                  '& .col-sm-1': {
                    float: 'right',
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    padding: '6px 0px 0px 0px',
                  },
                },
              },
            },
          },
        },

        '& .source-list-box.container-fluid': {
          padding: 0,

          '& .glyphicon-chevron-right': {
            color: palette.themePrimary,
            fontSize: 14,
            top: '1px',
          },
          '& .glyphicon-chevron-right:before': {
            content: '"\\E710"',
          },

          '& .row': {
            margin: 0,
            padding: 0,

            '& .button-add-remove': {
              padding: '0px 0px 0px 12px',
            },

            '& .item.container-fluid': {
              padding: '0px 0px 0px 12px',
              margin: 0,

              '& .col-sm-10': {
                paddingLeft: 20,
                margin: 0,
                width: 250,
                wordBreak: 'break-all',
              },

              '& .col-sm-2': {
                padding: 3,
                margin: 0,
                display: 'inline-block',
                float: 'right',

                '& .button-action.btn.btn-default': {
                  padding: 0,
                  maxHeight: 0,

                  '& .glyphicon': {
                    top: 0,
                  },
                },

                '& .button-action.btn.btn-default:hover': {
                  background: 'transparent',
                },
              },
            },
          },
        },
      },

      '& .selected': {
        border: `1px solid ${palette.neutralSecondary}`,
        padding: 0,
        width: 384,

        '& .selected-list-box-group.container-fluid': {
          padding: 0,
          margin: 0,

          '& .selected-list-box.container-fluid': {
            padding: '0px 0px 0px 10px',
            margin: 0,

            '& .glyphicon-chevron-left': {
              color: palette.themePrimary,
              fontSize: 14,
            },
            '& .glyphicon-chevron-left:before': {
              content: '"\\E738"',
            },

            '& .row': {
              margin: 0,
              padding: 0,

              '& .button-add-remove': {
                backgroundColor: 'transparent',
              },

              '& .category-name-button': {
                padding: 0,
                border: 'none',
              },
              '& .category-name-button:hover': {
                backgroundColor: 'transparent',
              },
              '& .category-name-button:focus': {
                border: 'none',
              },

              '& .item.container-fluid': {
                padding: 0,
                margin: 0,
                backgroundColor: 'transparent',
                border: 'none',

                '& .col-sm-2': {
                  padding: 0,
                  margin: 0,
                  display: 'inline-block',
                  float: 'left',
                  maxHeight: 25,

                  '& .button-action.btn.btn-default': {
                    margin: '-4px 0px 0px 0px',
                    padding: '0px',
                    minWidth: '20px',

                    '& .glyphicon': {
                      top: 0,
                    },
                  },
                },

                '& .col-sm-10': {
                  padding: 0,
                  margin: '0px 0px 0px -37px',
                  width: 300,
                  wordBreak: 'break-all',
                  display: 'inline-block',
                },
              },
            },
          },
        },
      },
    },
    '& .double-list-box': {
      padding: 0,
      width: 778,
      margin: '10px 0px',
      ...convertToLocalStyle(scrollbarStyle({ palette })),

      '& .category-action': {
        marginTop: '0px !important',
      },

      '& .row': {
        margin: 0,
      },

      '& .col-sm-12': {
        padding: 0,
      },

      '& .col-sm-5 > .row:first-child': {
        backgroundColor: 'transparent',
      },

      '& label.control-label': {
        height: '30px',
        textAlign: 'left',
        lineHeight: '30px',
        fontSize: '16px',
        fontWeight: 600,
        paddingTop: '5px',
      },

      '& .c113,.c118,.c1112': {
        backgroundColor: 'transparent',
      },

      '& .button-add-remove': {
        padding: 0,
        backgroundColor: 'transparent',
      },
      '& .button-add-remove:hover': {
        backgroundColor: 'transparent',
      },

      '& .button-back': {
        backgroundColor: 'transparent',
      },
      '& .button-back:hover': {
        backgroundColor: 'transparent',
      },

      '& .glyphicon': {
        fontFamily: iconFontFamily,
      },
      '& .glyphicon-chevron-left:before': {
        content: '"\\E76B"',
      },
      '& .glyphicon-chevron-right:before': {
        content: '"\\E76C"',
      },
      '& .glyphicon-chevron-up:before': {
        content: '"\\E70E"',
      },
      '& .glyphicon-chevron-down:before': {
        content: '"\\E70D"',
      },

      '& .source': {
        border: `1px solid ${palette.neutralSecondary}`,
        padding: 0,
        width: 384,

        '& .search-box': {
          height: 30,
          width: 375,
          margin: 0,

          '& .inputGroup': {
            height: 30,
            width: 375,
            margin: 0,
            display: 'flex',

            '& .iconba': {
              fontFamily: iconFontFamily,
            },

            '& .iconba-Search': {
              display: 'none',
            },

            '& input.input': {
              margin: '0px 10px',
              height: 30,
              width: 355,
              marginRight: -30,
              paddingRight: 30,
            },

            '& .iconba-Forward': {
              cursor: 'pointer',
              visibility: 'visible !important',
              marginTop: 2,
              color: palette.themePrimary,
              '&:before': {
                content: '"\\E721"',
              },
              '&:hover': {
                color: '#004578',
              },
            },
          },
        },

        '& .source-categories': {
          margin: 0,
          padding: 0,
          width: 382,

          '& .btn-group-vertical': {
            marginTop: '5px',
            width: 375,

            '& button.source-category': {
              margin: 0,
              padding: 0,
              height: 'auto',

              '& .container-fluid': {
                padding: 0,

                '& .row': {
                  margin: 0,

                  '& .col-sm-11': {
                    width: 340,
                    padding: '0px 0px 0px 10px',

                    '& .category-title': {
                      fontSize: '14px',
                      float: 'none',
                      padding: 0,
                    },

                    '& .category-description': {
                      fontSize: '12px',
                      margin: 0,
                    },
                  },

                  '& .col-sm-1': {
                    float: 'right',
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    padding: '25px 0px 0px 0px',
                  },
                },
              },
            },
          },
        },

        '& .source-list-box.container-fluid': {
          padding: 0,

          '& .glyphicon-chevron-right': {
            color: palette.themePrimary,
            fontSize: 14,
          },
          '& .glyphicon-chevron-right:before': {
            content: '"\\E710"',
          },

          '& .row': {
            margin: 0,
            padding: 0,

            '& .button-add-remove': {
              padding: '0px 0px 0px 12px',
            },

            '& .item.container-fluid': {
              padding: '0px 0px 0px 12px',
              margin: 0,

              '& .col-sm-10': {
                padding: 0,
                margin: 0,
                width: 300,
                wordBreak: 'break-all',
              },

              '& .col-sm-2': {
                padding: 0,
                margin: 0,
                display: 'inline-block',
                float: 'right',

                '& .button-action.btn.btn-default': {
                  padding: 0,
                  maxHeight: 25,
                  minWidth: 20,
                  margin: '-4px 0px 0px 0px',

                  '& .glyphicon': {
                    top: 0,
                  },
                },

                '& .button-action.btn.btn-default:hover': {
                  background: 'transparent',
                },
              },
            },
          },
        },
      },

      '& .selected': {
        border: `1px solid ${palette.neutralSecondary}`,
        padding: 0,
        width: 384,

        '& .selected-list-box-group.container-fluid': {
          padding: 0,
          margin: 0,

          '& .selected-list-box.container-fluid': {
            padding: '0px 0px 0px 10px',
            margin: 0,

            '& .glyphicon-chevron-left': {
              color: palette.themePrimary,
              fontSize: 14,
            },
            '& .glyphicon-chevron-left:before': {
              content: '"\\E738"',
            },

            '& .row': {
              margin: 0,
              padding: 0,

              '& .button-add-remove': {
                backgroundColor: 'transparent',
              },

              '& .category-name-button': {
                padding: 0,
                border: 'none',
              },
              '& .category-name-button:hover': {
                backgroundColor: 'transparent',
              },
              '& .category-name-button:focus': {
                border: 'none',
              },

              '& .item.container-fluid': {
                padding: 0,
                margin: 0,
                backgroundColor: 'transparent',
                border: 'none',

                '& .col-sm-2': {
                  padding: 0,
                  margin: 0,
                  display: 'inline-block',
                  float: 'left',
                  maxHeight: 25,

                  '& .button-action.btn.btn-default': {
                    padding: 0,
                    margin: '0px 0px 0px -28px',
                    backgroundColor: 'transparent',

                    '& .glyphicon': {
                      top: 0,
                    },
                  },
                },

                '& .col-sm-10': {
                  padding: 0,
                  margin: '0px 0px 0px -37px',
                  width: 300,
                  wordBreak: 'break-all',
                  display: 'inline-block',
                },
              },
            },
          },
        },
      },
    },

    '& .add-new-audience-set-button': {
      backgroundColor: palette.blue,
      color: palette.white,
    },

    '& .existing-audience-set-container': {
      '& .audience-set-panel-list-container': {
        '& ol': {
          padding: 0,
        },
        '& div': {
          padding: 0,
          marginBottom: 10,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    },

    '& .operator-selector': {
      marginLeft: 0,
    },

    '& .audience-set-edit-panel-buttons': {
      marginLeft: 0,
      '& .btn': {
        marginRight: 12,
      },
    },
  },
});
